import React from "react";
import CrossIcon from "../../../Icons/CrossIcon";
import { tw } from "@careinfo/tailwind";
import { ClientAccessControl } from "@careinfo/permission-required";

const ReceiveCell = ({ row, handleReceive }) => {
  return (
    <div>
      <ClientAccessControl
        allowedPermissions={["can_manually_receive_item"]}
        renderNoAccess={
          <button
            type="button"
            disabled={true}
            onClick={() => handleReceive(row?.original?.order?.tracking_number)}
            className={tw`focus:outline-none`}
          >
            <CrossIcon />
          </button>
        }
      >
        <button
          type="button"
          onClick={() => handleReceive(row?.original?.order?.tracking_number)}
          className={tw`focus:outline-none`}
        >
          <CrossIcon />
        </button>
      </ClientAccessControl>
    </div>
  );
};

export default ReceiveCell;
